// extracted by mini-css-extract-plugin
export default {"link":"CertificateFileLink_link__J5aZ1"};